import * as types from '../actions/_actionTypes';
import initialState from './_initialReducerState'

export default function ReclassifyReducer(state = initialState.reclassify, action: any) {
  switch (action.type) {
    case types.SAVE_RECLASSIFY_SUCCESS:
      return action.reclassify;
    default:
      return state;
  }
}
